import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Icon } from '@/ui'
import { PLAN_AND_BILLING_PATH } from './paths'

interface BillingSubpageBreadcrumbProps {
  currentPage: string
}

export const BillingSubpageBreadcrumb = ({
  currentPage,
}: BillingSubpageBreadcrumbProps): JSX.Element => {
  const navigate = useNavigate()
  return (
    <Breadcrumb>
      <Breadcrumb.List>
        <Breadcrumb.Item>
          <Breadcrumb.Link onClick={() => navigate(PLAN_AND_BILLING_PATH)}>
            <Icon icon={faArrowLeft} />
            Plan and Billing
          </Breadcrumb.Link>
        </Breadcrumb.Item>
        <Breadcrumb.Separator />
        <Breadcrumb.Item>
          <Breadcrumb.Page>{currentPage}</Breadcrumb.Page>
        </Breadcrumb.Item>
      </Breadcrumb.List>
    </Breadcrumb>
  )
}
